import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  proposalDetailsSection: { listStyle: 'none', padding: 0, margin: 0 },
  proposalDetailsRecord: { marginBottom: '0.2rem', display: 'flex' },
  proposalDetailKey: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 400 },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
    paddingRight: '2rem',
    width: '13.2rem',
  },
  productLineValue: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 700 },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
    maxWidth: '48rem',
  },
  portfoliosList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '3rem',
    flex: 1,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
